import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();

//CARGA DE LA FUENTE
if(!!brandStyles.fonts.link){
	var head = document.head;
	var link = document.createElement("link");
	link.type = "text/css";
	link.rel = "stylesheet";
	link.href = 'https://fonts.googleapis.com/css?'+brandStyles.fonts.link;
	head.appendChild(link);
}

if(!!brandStyles.ownstyles){
	var head = document.head;
	var link = document.createElement("link");
	link.type = "text/css";
	link.rel = "stylesheet";
	link.href = brandStyles.ownstyles;
	head.appendChild(link);
}

if(!!brandStyles.cookieyes){
	var head = document.head;
	var link = document.createElement("script");
	link.type = "text/javascript";
	link.id = "cookieyes";
	link.src = brandStyles.cookieyes;
	head.appendChild(link);
}




const styles = {
	state: brandStyles,
	getters: {
		getLogo : state => state.logo,
		getLogoColor : state => state.logocolor,
		getLogoEncabezado : state => state.logoencabezado,
		getLogoSize : state => state.logoSize,
		getBrand : state => state,
		getFonts : state =>{
			if(state.fonts){
				return state.fonts
			}else {
				let fonts = {
					principal : "'Lato', sans-serif",
					secundaria : "'Nunito', sans-serif"
				}
				return fonts;
			}
		},
		basicColors : (state, getters) => {

			let colors;

			let how = (getters.getDarkSide) ? 'darkMode' : 'default';

			colors = {
				basic : state.basic[how],
				basicAlternative : state.basic.alternative,
				fontAlternative : state.basic.fontAlternative,
				button : state.button[how],
				buttonFont : state.button.font,
				soft_basic : state.soft_basic[how],
				white : state.white[how],
				dark_black : state.dark_black[how],
				medium_black : state.medium_black[how],
				soft_black : state.soft_black[how],
				light_black : state.light_black[how],
				text_black : state.text_black[how],
			}

			return colors; 

		},
		getStyles : (state, getters) => {
			return {
				colorBasic : {
					color : getters.basicColors.basic
				},
				colorBasicAlternative : {
					color : getters.basicColors.basicAlternative
				},
				colorButton : {
					color : getters.basicColors.button
				},
				colorTextBlack : {
					color : getters.basicColors.text_black
				},
				colorDarkBlack : {
					color : getters.basicColors.dark_black
				},
				colorMediumBlack : {
					color : getters.basicColors.medium_black
				},
				fontColorButton :{
					color : getters.basicColors.buttonFont
				},
				contenedor_imagen : {
					background : getters.basicColors.soft_black
				},
				backgroundWhite : {
					background : getters.basicColors.white	
				},
				fontSecondary : {
					'font-family' : getters.getFonts.secundaria
				}
			}
		},
		getFooterText : (state,getters) => {
			if(!!state.footer[getters.getLanguage]){
				return state.footer[getters.getLanguage].textos
			}
		},
		getFooterLinks : (state,getters) => {
			if(!!state.footer[getters.getLanguage]){
				return state.footer[getters.getLanguage].links
			}
		},
		getBackground : state => {
			if(!!state.background){
				return state.background;
			}
		},
		getQuitarCampoDiscapacidad : state =>{
			if(!!state.quitarCampoDiscapacidad){
				return state.quitarCampoDiscapacidad;
			}
		},
		getPDFPropuestaPracticas : state => {
			if(!!state.instruccionesPropuestaPracticas){
				return state.instruccionesPropuestaPracticas;
			}
		},
		getOwnlogin : state => {
			if(!!state.ownlogin){
				return state.ownlogin;
			}
		},
		getClient : state => {
			if(!!state.name){
				return state.name;
			}
		},
		getShowPropuestaPracticas : state => {
			if(!!state.showPropuestaPracticas){
				return state.showPropuestaPracticas
			}
		},
		getInMantenimiento : state => {
			if(!!state.inMantenimiento){
				return state.inMantenimiento
			}
		},
		getInProduction : state => {

			let inproduccion = false;

			if(!!state.dominio_produccion){
				if(state.dominio_produccion == location.hostname){
					inproduccion = true;
				}
			}
			
			return inproduccion
		},
		getDocumentosPracticasOptions : state =>{
			if(!!state.documentosPracticas){
				return state.documentosPracticas
			}
		},
		getRequestEmpresaDestino : state =>{
			if(!!state.requestEmpresaDestino){
				return state.requestEmpresaDestino
			}
		},
		getRequestDireccionContactoEmpresa : state =>{
			if(!!state.requestDireccionContactoEmpresa){
				return state.requestDireccionContactoEmpresa
			}
		},
		getRequestDireccionFullContactoEmpresa : state =>{
			if(!!state.requestDireccionFullContactoEmpresa){
				return state.requestDireccionFullContactoEmpresa
			}
		},
		getRequestTipoEmpresa : state =>{
			if(!!state.requestTipoEmpresa){
				return state.requestTipoEmpresa
			}
		},
		isCVRequired : state =>{
			if(!!state.CVRequired){
				return state.CVRequired
			}
		},
		getCanDuplicarOferta : state =>{
			if(state.canDuplicarOferta){
				return state.canDuplicarOferta
			}
		},
		getCanDuplicarOfertaInvertida : state =>{
			if(state.canDuplicarOfertaInvertida){
				return state.canDuplicarOfertaInvertida
			}
		},
		getOtrasRemuneracionesEnPracticas : state =>{
			if(state.otrasRemuneracionesEnPracticas){
				return state.otrasRemuneracionesEnPracticas
			}
		},
		canUploadDocEmpresas : state => {
			return (state.canUploadDocEmpresas) ? state.canUploadDocEmpresas : false
		},
		haveDocumentosPracticas : state => {
			return (state.haveDocumentosPracticas) ? state.haveDocumentosPracticas : false
		}
	},

	mutations: {
		setStyles :function(state, data){
			state.basic = data.basic;
			state.dark_black = data.dark_black;
			state.medium_black = data.medium_black;
			state.soft_black = data.soft_black;
			state.light_black = data.light_black;
			state.white = data.white;
			(!!data.logo) ? state.logo = data.logo : '';
		}
	}
}

export default styles;



// WEBPACK FOOTER //
// ./src/store/styles.js